define('mediaGallery/mediaGallery',[
],
    function () {

        const mediaGallerySelector = ".media-gallery";
        const swiperSelector = "div[id^='media_gallery_swiper_']";
        const thumbsSelector = "div[id^='media_gallery_thumbs_']";
        window.photoSwipeIndex = 0;
        var slidesCollection = [];
        const MAIN_SLIDER = "main";
        const THUMBS_SLIDER = "thumbs";
        const IMAGE = "Image";
        const VIDEO = "Video";
        const VARIANT_IMAGE = "VariantImage";
        var filteredVideosClicked = [];
        var showVideosClicked = false;
        
        // ZOOM & PINCH MEDIA GALLERY
        function initZoomAndPinch(slidesSelector) {
            slidesSelector = slidesSelector || '.media-gallery .main .swiper-slide';
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                setTimeout(function () {
                    var divs = document.querySelectorAll(slidesSelector + ' .swiper-image-container img').forEach(function (el) {
                        new PinchZoom(el, {
                            tapZoomFactor: 3,
                            minZoom: 1,
                            maxZoom: 3
                        });
                    });
                }, 250);
            }
            else {
                // Thumbnail hovers
                $(".thumb-slide").off('click').on('click', function () {                   
                    var parent = $(this).parent();
                    var slideIndex = parent.children().index($(this)[0]);
                    var swiperContainer = $(this).closest(mediaGallerySelector).find(swiperSelector);
                    var galleryNumber = 0;
                    if (swiperContainer && swiperContainer.length) {
                        var swiper = swiperContainer[0].swiper;
                        galleryNumber = $(swiperContainer).attr("id").replace("media_gallery_swiper_", "");
                        setTimeout(function () {
                            swiper.slideTo(slideIndex);
                        }, 250);
                    }
                    else {
                        var thumbsElement = $(parent).closest(thumbsSelector);
                        if (thumbsElement && thumbsElement.length)
                            galleryNumber = $(thumbsElement).attr("id").replace("media_gallery_thumbs_", "");
                    }
                    window.photoSwipeIndex = slideIndex;
                    var ev = {};
                    ev.data = {};
                    ev.data.thumbsClick = true;
                    ev.data.galleryNumber = galleryNumber;
                    displayPhotoSwipe(ev);
                });
            }
        }

        function monitorIframe() {
            // SET INTERVAL TO DETECT IFRAME CLICK
            var monitor = setInterval(function(){
                var elem = document.activeElement;
                if(elem && elem.tagName == 'IFRAME'){
                    elem.blur();
                    $('.media-gallery').addClass('video-playing');
                    clearInterval(monitor);
                }
            }, 100);
        }

        (function loadDynamicIframe() {
            // ADD DEFAULT YOUTUBE IMAGE TO IFRAME
            $('.media-gallery .video-embed').each(function(){
                var y = $(this).attr('data-thumb');
                $(this).css('background-image','url('+ y + ')');
            });
            // REPLACE DEFAULT YOUTUBE IMAGE WITH YOUTUBE
            $('.media-gallery .video_wrapper .icon-play').on('click',function(){
                var b = $(this).next().attr('data-src');
                $(this).next().attr('src',b);
                $(this).remove();
            });
            $('.media-gallery .video_wrapper .play-icon').on('click', function () {
                var b = $(this).next().attr('data-src');
                $(this).next().attr('src', b);
                $(this).remove();
            });
            monitorIframe();
        }());

        function position(galleryNumber, slideId) {
            var swiperContainer = $("#media_gallery_swiper_" + galleryNumber);
            if (swiperContainer.length) {
                var swiper = swiperContainer[0].swiper;
                if (swiper) {
                    var slideIndex = $(swiperContainer).find(".swiper-slide[data-slide-id=" + slideId + "]").index(".swiper-slide");
                    if (slideIndex >= 0) {
                        swiper.slideTo(slideIndex, 0);
                        displayCaptionForCurrentSlide(swiper);                        
                    }
                }
            }
        }

        function getMediaGallerySwiper(galleryNumber) {
            var swiperContainerSelector = "#media_gallery_swiper_" + galleryNumber;            
            var swiperContainer = $(swiperContainerSelector);
            if (!swiperContainer.length) return null; // no swiper container - nothing to do
            var swiper = swiperContainer[0].swiper;
            if (!swiper) return null; // no swiper initializaed - nothing to do

            return swiper;
        }

        function displayVariantImages(galleryNumber, variantImageId, additionalVariantImages) {             
            if (!window.mediaGalleryData || !window.mediaGalleryData.variantImages) return;  // there's no mediaGalleryData to work with
        
            var swiperContainerSelector = "#media_gallery_swiper_" + galleryNumber;           
            var swiperContainer = $(swiperContainerSelector);           
            var swiper = getMediaGallerySwiper(galleryNumber);
            if (!swiper) return; // no swiper initializaed - nothing to do

            var variantImageSlideSelector = swiperContainerSelector + " .swiper-slide[data-slide-type=VariantImage]";
            
            var swiperChanged = false;
            // first, remove currently displayed variant images
            $(variantImageSlideSelector).each(function (index, slideElement) {
                var slideIndex = $(slideElement).index(".swiper-slide");
                swiper.removeSlide(slideIndex);
                swiper.thumbs.swiper.removeSlide(slideIndex);
                swiperChanged = true;
            });

            // then, add images given as parameters
            var imagesToAdd = variantImageId ? [variantImageId].concat(additionalVariantImages) : additionalVariantImages;
            if (imagesToAdd.length) {
                var slideCssClass = $(swiperContainer).data("slideCssClass");
                var thumbnailSlideCssClass = $(swiperContainer).data("thumbnailSlideCssClass");

                var slidesToAdd = [];
                var thumbnailsToAdd = [];
                // delete old variant images from slides collection               
                slidesCollection = slidesCollection.filter(x => x.dataType != VARIANT_IMAGE);               
                imagesToAdd.forEach(function (imageId) {
                    var variantImage = mediaGalleryData.variantImages[imageId];
                    //checking if variant image exist (if image is unpublished it will be undefined and it will raise error in javascript)
                    if (variantImage) {
                        var slideToAdd = getSlideHtml(slideCssClass, imageId, variantImage.caption, variantImage.url, variantImage.alt);
                        slidesToAdd.push(slideToAdd);                       
                        var thumbSlide = getThumbnailSlideHtml(thumbnailSlideCssClass, variantImage.thumbnailUrl, variantImage.alt);
                        thumbnailsToAdd.push(thumbSlide);                        
                    }
                });
                                
                swiper.prependSlide(slidesToAdd.reverse());
                swiper.thumbs.swiper.prependSlide(thumbnailsToAdd.reverse());               
                // because of option to display only videos, we deleted also Images from slider, now we need to add them (Image not VariantImage)
                addTypeToSlider(swiper, IMAGE);                  
                var videoSlideSelector = swiperContainerSelector + " .swiper-slide[data-gallery-media-type=Video]";
                // save video slides, if they are empty (only at first load)               
                saveVideoSlidesIfNeeded(swiper, videoSlideSelector);
                // remove added video slides because we want to show only images on first load
                removeSlides(swiper, videoSlideSelector);

                swiperChanged = true;
            }

            if (swiperChanged) {               
                swiper.slideTo(0, 0);
                swiper.thumbs.swiper.slideTo(0, 0);
                // do the required initializations for newly added slides
                initZoomAndPinch(variantImageSlideSelector);
                $(variantImageSlideSelector).off('click').on('click', { "galleryNumber": galleryNumber }, displayPhotoSwipe);
                dispatchResizeEvent();
                displayCaptionForCurrentSlide(swiper);     
                for (var i = 0; i < slidesToAdd.length; i++) {
                    slidesCollection.push({ "sliderType": MAIN_SLIDER, "dataType": VARIANT_IMAGE, "slide": swiper.slides[i] });
                    slidesCollection.push({ "sliderType": THUMBS_SLIDER, "dataType": VARIANT_IMAGE, "slide": swiper.thumbs.swiper.slides[i] });
                }

                var photoBtn = $(".media-gallery-photo-video-buttons").find('button[data-gallery-number="' + galleryNumber + '"]').has('i.icon-image');                
                if (photoBtn.length)
                    window.ShowMediaGalleryInPhotoSwipe(photoBtn, false);
            }
        }

        // for adding images/variant images/videos from saved object
        function addTypeToSlider(swiper, imageType) {            
            var changed = false;
            var mainSliderImages = slidesCollection.filter(x => x.sliderType == MAIN_SLIDER && x.dataType == imageType).map(x => x.slide);
            var thumbsSliderImages = slidesCollection.filter(x => x.sliderType == THUMBS_SLIDER && x.dataType == imageType).map(x => x.slide);
            if (mainSliderImages.length > 0) {     
                swiper.appendSlide(mainSliderImages);
                swiper.thumbs.swiper.appendSlide(thumbsSliderImages);
                changed = true;
            }

            return changed;
        }

        function getSlideHtml(cssClass, slideId, slideCaption, imageUrl, alt) {
            return '<div class="swiper-slide main-slide ' + cssClass + '"' +
                'data-slide-id="' + slideId + '"' +
                'data-slide-type="VariantImage"' +
                'data-gallery-media-type="VariantImage"' +
                'data-slide-caption="' + slideCaption + '">' +
                '<div class="swiper-zoom-container spinner-background">' +
                '<a class="easyzoom" href="' + imageUrl + '" onclick="return false;">' +
                '<img alt="' + alt + '" data-src="' + imageUrl + '" class="swiper-lazy"/>' +
                '</a>' +
                '<div class="swiper-lazy-preloader"></div>' +
                '</div>' +
                '</div>';
        }

        function getThumbnailSlideHtml(cssClass, imageUrl, alt) {
            return '<div data-gallery-media-type="VariantImage" class="swiper-slide thumb-slide ' + cssClass + '">' +
                '<div class="swiper-zoom-container spinner-background">' +
                '<img src="' + imageUrl + '" alt="' + alt + '"/>' +
                '</div>' +
                '</div>';
        }

        function displayCaptionForCurrentSlide(swiper) {          
            window.currentUrl = window.location.href;
            var slide = swiper.slides[swiper.realIndex];
            window.photoSwipeIndex = swiper.realIndex;            
            // Taking the caption for variant images from the Javascript object, and for other images from their data-slide-caption attribute.
            // (This is because double quote characters are causing problems in variant image slide, which are generated dynamically in runtime.)
            var imageId = $(slide).data("slideId");
            var variantImage = mediaGalleryData.variantImages ? mediaGalleryData.variantImages[imageId] : null;
            var captionHtmlEncoded = variantImage ? variantImage.caption : $(slide).data("slideCaption");
            // caption string is HTML encoded (so it doesn't mess up Javascript object or data attribute), now we have to decode it back
            var textArea = document.createElement('textarea');
            textArea.innerHTML = captionHtmlEncoded;
            var caption = textArea.value;

            $(slide).closest(mediaGallerySelector).find(".caption").empty().html(caption);
            if($('.media-gallery').hasClass('video-playing')) {
                $('.media-gallery').removeClass('video-playing'); 
                $('.media-gallery .video-embed').each(function(){
                    var el_src = $(this).attr("src");
                    $(this).attr("src",el_src);
                });
                monitorIframe();  
            }
        }

        // thumbsClick parameter tell us if we have clicked on thumbnail (true), or we clicked on image in carousel (false)
        // if we clicked on image - open photo swipe
        // if we clicked on thumbnail - don't open photo swipe, just change carousel slide or if photo swipe is already opened, just change photo swipe image to follow thumbnail image we clicked
        function displayPhotoSwipe(event) {
            var urlParams = new URLSearchParams(window.location.search);
            var variant = urlParams.get('v');
            var photoSwipeItems = [];
            var galleryNumber = event.data.galleryNumber;          
            if (galleryNumber)
                photoSwipeItems = photoSwipeGalleryItems[galleryNumber - 1];
            var datasource = photoSwipeItems.filter(x => x.variant == variant || x.variant == "all");  
            if (datasource && datasource.length > 0) {
                for (var i = 0; i < datasource.length; i++) {
                    var datasourceItem = datasource[i];
                    // remove maximum width for images from carousel, show them in the full size
                    datasourceItem.src = datasourceItem.src.replace("mw=700", "");
                }
            }     
            //check if PhotoSwipe is already opened
            var photoSwipeOpened = $(".pswp--open");
            var isPhotoSwipeOpened = photoSwipeOpened && photoSwipeOpened.length;          
            // for some reason this is not working because of that we are using jquery selector
            // const pswp = window.lightbox.pswp;   
            var thumbsClick = event.data.thumbsClick;           
            if (thumbsClick == true) {
                if (isPhotoSwipeOpened) {
                    const pswp = window.lightbox.pswp;
                    if (!pswp) window.lightbox.loadAndOpen(window.photoSwipeIndex, datasource);
                    else {
                        if (pswp.isOpen)
                            pswp.goTo(window.photoSwipeIndex);
                        else
                            window.lightbox.loadAndOpen(window.photoSwipeIndex, datasource);
                    }
                }               
            }
            else
                window.lightbox.loadAndOpen(window.photoSwipeIndex, datasource);
        }

        function displayGalleryPopup(event) {
            if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
                setTimeout(function () {
                    //$('.easyzoom').EasyZoomMagnifierReset();

                    if (!$(".modal-gallery").hasClass("open-modal")) {
                        $('.modal-gallery').addClass('open-modal');
                    }
                    dispatchResizeEvent();
                }, 250);
            }
        }

        function closeGalleryPopup(event) {
            //e.preventDefault();
            var data = $(".swiper-container.main").data();

            $(".swiper-lazy.swiper-lazy-loaded").css("transform", "translate3d(0px, 0px, 0px) scale(1)");
            $(".swiper-zoom-container").css("transform", "translate3d(0px, 0px, 0px)");

            $('.modal-gallery').removeClass('open-modal');
            //$('.easyzoom').EasyZoomMagnifier();

            dispatchResizeEvent();
        }

        function dispatchResizeEvent() {
            var event;
            if (typeof (Event) === 'function') {
                event = new Event('resize');
            } else {
                event = document.createEvent('Event');
                event.initEvent('resize', false, false);
            }

            window.dispatchEvent(event);
        }

        function updateFilteringButtonToActive(btn) {
            $(btn).closest(".media-gallery-photo-video-buttons").find("button").removeClass("active");
            $(btn).addClass("active");
        }

        // for filtering videos/images
        window.ShowMediaGalleryInPhotoSwipe = function (btn, showVideos) {              
            if (showVideosClicked && showVideos) return;
            updateFilteringButtonToActive(btn);
            var galleryNumber = $(btn).data("galleryNumber"); 
            // on initial load we are displaying only photos, if we click on Photo button, don't do anything
            var filteredVideoClicked = filteredVideosClicked.find(x => x == galleryNumber);
            if (!showVideos && !filteredVideoClicked) return;
            if (showVideos) {
                if (!filteredVideosClicked.includes(galleryNumber))
                    filteredVideosClicked.push(galleryNumber);
            }
            else {               
                if (filteredVideosClicked.includes(galleryNumber))
                    filteredVideosClicked.splice(filteredVideosClicked.findIndex(item => item == galleryNumber), 1);
            }
            var swiperContainerSelector = "#media_gallery_swiper_" + galleryNumber;    
            var videoSlideSelector = swiperContainerSelector + " .swiper-slide[data-gallery-media-type=Video]";
            var imageSlideSelector = swiperContainerSelector + " .swiper-slide[data-gallery-media-type=Image]";
            var variantImageSlideSelector = swiperContainerSelector + " .swiper-slide[data-gallery-media-type=VariantImage]";
            var swiper = getMediaGallerySwiper(galleryNumber);
            if (!swiper) return; // no swiper initializaed - nothing to do     
            var changed = handleImageOrVideoSlides(swiper, galleryNumber, showVideos, imageSlideSelector, videoSlideSelector, variantImageSlideSelector);
            if (changed) {
                swiper.slideTo(0, 0);
                displayCaptionForCurrentSlide(swiper);    
                swiper.update();
            }

            showVideosClicked = showVideos;
        }

        // save videos
        function saveVideoSlidesIfNeeded(swiper, videoSlideSelector) {
            var mainSliderVideos = slidesCollection.filter(x => x.sliderType == MAIN_SLIDER && x.dataType == VIDEO).map(x => x.slide);
            if (mainSliderVideos.length == 0) {
                $('div[data-gallery-media-type="Video"]').removeClass("d-none"); 
                $(videoSlideSelector).each(function (index, slideElement) {
                    var slideIndex = $(slideElement).index(".swiper-slide");
                    slidesCollection.push({ "sliderType": MAIN_SLIDER, "dataType": VIDEO, "slide": swiper.slides[slideIndex] });
                    slidesCollection.push({ "sliderType": THUMBS_SLIDER, "dataType": VIDEO, "slide": swiper.thumbs.swiper.slides[slideIndex] });                    
                    swiper.removeSlide(slideIndex);
                    swiper.thumbs.swiper.removeSlide(slideIndex);
                });
            }
        }

        function handleImageOrVideoSlides(swiper, galleryNumber, showVideos, imageSlideSelector, videoSlideSelector, variantImageSlideSelector) {   
            var changed = removeSlides(swiper, variantImageSlideSelector); 
            $("#media_gallery_swiper_" + galleryNumber).closest(".media-gallery").find(".caption").html("");
            if (showVideos) {  
                // we need to save videos if it is case study or sample rooms, they don't have variant images
                saveVideoSlidesIfNeeded(swiper, videoSlideSelector);

                // save all images and remove them from slider
                $(imageSlideSelector).each(function (index, slideElement) {
                    var slideIndex = $(slideElement).index(".swiper-slide");
                    slidesCollection.push({ "sliderType": MAIN_SLIDER, "dataType": IMAGE, "slide": swiper.slides[slideIndex] });       
                    slidesCollection.push({ "sliderType": THUMBS_SLIDER, "dataType": IMAGE, "slide": swiper.thumbs.swiper.slides[slideIndex] });                   
                    swiper.removeSlide(slideIndex);
                    swiper.thumbs.swiper.removeSlide(slideIndex);
                    changed = true;
                });
                // add only videos
                var addedVideo = addTypeToSlider(swiper, VIDEO);                
                changed = changed || addedVideo;                           
            }
            else {                  
                // remove all videos
                var removedVideo = removeSlides(swiper, videoSlideSelector); 
                // add variant images at first
                var addedVariantImage = addTypeToSlider(swiper, VARIANT_IMAGE);
                // add images after variant images
                var addedImage = addTypeToSlider(swiper, IMAGE);               
                changed = changed || removedVideo || addedImage || addedVariantImage;                
            }

            return changed;
        }

        function removeSlides(swiper, slideSelector) {
            var changed = false;
            $(slideSelector).each(function (index, slideElement) {
                var slideIndex = $(slideElement).index(".swiper-slide");
                swiper.removeSlide(slideIndex);
                swiper.thumbs.swiper.removeSlide(slideIndex);
                changed = true;
            });

            return changed;
        }
               
        return {
            position: position,
            displayVariantImages: displayVariantImages,
            displayCaptionForCurrentSlide: displayCaptionForCurrentSlide,
            mediaGallerySelector: mediaGallerySelector,
            swiperSelector: swiperSelector,
            thumbsSelector: thumbsSelector,
            displayGalleryPopup: displayPhotoSwipe,
            closeGalleryPopup: closeGalleryPopup,
            initZoomAndPinch: initZoomAndPinch
        };
    });

